<template>
  <div
    class="
      custom-group-tours-hero
      relative
      pt-32
      pb-100
      mb-py-0
      overflow-hidden
    "
  >
    <div class="container flex items-center mb-flex-column">
      <div class="absolute top-0 z-3 mb-px-20 py-80 wp-100">
        <div class="text" :style="$route.name === SCHOOL_TOUR_ROUTE.name ? 'max-width: 900px;' : 'max-width: 672px;'">
          <h1
            class="
              fw-700
              fs-60
              mb-fs-42
              lh-66
              mb-lh-46
              flex flex-column
              mb-24
              relative
              ls-1
              white
            "
          >
            {{ $route.name === SCHOOL_TOUR_ROUTE.name ? SCHOOL_HERO_TITLE : HERO_TITLE }}
          </h1>
          <div class="content ls-2 mb-243 white">
            <p
              class="fw-600 fs-20 mb-fs-18 lh-24 mb-lh-22"
              v-html='heroText'
            />
          </div>
          <CGTButtons :title="HERO_CTA" color="white" class="mb-120" />
        </div>
        <div
          class="flex flex-row mb-flex-column wp-100 grid-gap-80 mb-grid-gap-20"
        >
          <CGTHeroItem
            v-for="(item, key) in HERO_ITEMS(ASSETS_CDN)"
            :key="key"
            :data="item"
          />
        </div>
      </div>
<!--      <div v-if='$route.name === SCHOOL_TOUR_ROUTE.name' class="z-1 el-cover"
           style='background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 55.21%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(127deg, rgba(0, 0, 0, 0.35) 30.83%, rgba(0, 0, 0, 0.14) 50.69%, rgba(0, 0, 0, 0.00) 62.09%), linear-gradient(0deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%);'></div>-->
      <img
        :src="heroBg"
        class="z-0 el-cover"
        :alt="heroAlt"
      />
    </div>
  </div>
</template>

<script setup>
import {
  HERO_TITLE,
  HERO_TEXT,
  HERO_CTA,
  HERO_ITEMS,
} from '~/constant/customGroupTours'
import {
  SCHOOL_HERO_TITLE,
  SCHOOL_HERO_TEXT
} from '~/constant/schoolTourDetails'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'
import CGTButtons from '~/components/pages/LandingPage/components/CGTButtons.vue'
import CGTHeroItem from '~/components/pages/LandingPage/CGTHero/CGTHeroItem.vue'
import {assetCDN} from '~/helper/index.js'
import { computed } from 'vue'
const ASSETS_CDN = assetCDN()
import { useRoute } from 'vue-router'

const route = useRoute()

const heroText = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return SCHOOL_HERO_TEXT
  return HERO_TEXT
})

const heroBg = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return 'https://s3-cdn.designerjourneys.com/static-banners/designer-journeys-school-tour-details-hero.jpg'
  return `${ASSETS_CDN}/images/customgrouptour/Hero-min.jpg`
})

const heroAlt = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return "Unforgettable school trips to any of our 75 amazing destinations, ready to be advertised to your clients."
  return "Unforgettable group tours to any of our 75 amazing destinations, ready to be advertised to your clients."
})

</script>

<style lang="scss" scoped>
.custom-group-tours-hero {
  min-height: 740px;

  @include phone() {
    min-height: 1000px;
  }
}
.text {
  //max-width: 672px;
  .text-icon {
    top: -25px;
    left: -35px;
    @include phone() {
      top: -15px;
      left: -25px;
    }
  }
}

.banner {
  @include tablet() {
    max-width: 428px;
  }
}
.background {
  width: 759px;
  height: 830px;
  background: linear-gradient(
    180deg,
    rgba(231, 255, 232, 0.05) 0%,
    #c3ffd9 50%,
    rgba(231, 255, 232, 0) 100%
  );
  filter: blur(100px);
  transform: matrix(-1, 0, 0, 1, 0, 0);

  @include phone() {
    width: 100%;
    height: 50%;
    min-height: 500px;
    top: 68%;
    left: 10%;
  }
}
</style>
